module.exports = __webpack_public_path__ + "img/higherrisk.deed418e.png";